import React from 'react'
import AddToCartButton, {
  AddToCartButtonProps
} from '@components/product/AddToCartButton'
import Translations from '@helpers/translations'
import styles from './styles.module.scss'

type GiftCardAddToBasketProps = {
  active: boolean
  handleOnClick: AddToCartButtonProps['onAddToCart']
  handle: string
}

const GiftCardAddToBasket = ({
  handleOnClick,
  active,
  handle
}: GiftCardAddToBasketProps) => {
  return (
    <div className={styles.giftCard__submit}>
      <AddToCartButton
        active={active}
        onAddToCart={handleOnClick}
        handle={handle}
        isSelectedProductOutOfStock={false}
        onOutOfStock={() => undefined}
      />
      <p className={styles.giftCard__delivery}>
        {Translations.localise('product.gift-card.free-returns')}
      </p>
    </div>
  )
}

export default GiftCardAddToBasket
